import React from 'react';
import { Icon } from 'ui';

const NothingToGrade = props => {
  return (
    <div className="p-16 border-gray-light border bg-white d-f jc-c fd-c ai-c minh-300 h-100p">
      <Icon name="thumbsup_sparkle" className="h-70 w-110" />
      <p className="fz-24 lh-32 fw-b">{t('grades.nothing_to_grade')}</p>
    </div>
  );
};

export default NothingToGrade;
